import React from 'react';

export default function RechnungEmpfangenSectionPricingWhitePattern8() {
    return (
        <React.Fragment>
            <>
                <section className="py-20 xl:py-24 bg-white overflow-hidden" style={{backgroundImage: 'url("flex-ui-assets/elements/pattern-white.svg")', backgroundPosition: 'center'}}>
  <div className="container px-4 mx-auto">
    <div className="text-center">
      <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-green-500 bg-green-100 font-medium uppercase rounded-9xl">Pricing</span>
      <h3 className="mb-4 text-3xl md:text-5xl text-coolGray-900 font-bold tracking-tighter">Preise</h3>
      <p className="mb-6 text-lg md:text-xl text-coolGray-500 font-medium">Pricing that scales with your business immediately.</p>
      <div className="flex mb-12 mx-auto max-w-max border border-coolGray-200 overflow-hidden rounded-md shadow-lg">
        <a className="py-3 px-5 text-sm text-green-500 bg-white font-medium border-r border-coolGray-200" href="#">Montlicher Preis netto</a>
      </div>
    </div>
    <div className="flex flex-wrap justify-center -mx-4">
      <div className="w-full md:w-1/2 p-4">
        <div className="flex flex-col pt-8 pb-8 bg-coolGray-50 rounded-md shadow-md hover:scale-105 transition duration-500">
          <div className="flex items-center justify-between px-8">
            <div>
              <h3 className="text-2xl md:text-3xl text-coolGray-800 font-semibold tracking-tighter">Fina CRP Basis</h3>
              <p className="text-coolGray-400 font-medium">For bigger teams</p>
            </div>
            <div>
              <span className="relative -top-10 right-1 text-3xl text-coolGray-900 font-bold">€</span>
              <span className="text-6xl md:text-7xl text-coolGray-900 font-semibold tracking-tighter">99</span>
              <span className="inline-block ml-1 text-coolGray-500 font-semibold">/mo</span>
            </div>
          </div>
          <div className="border-b border-coolGray-100" />
          <ul className="self-start px-8 pt-8 pb-16">
            <li className="flex items-center mb-4 text-coolGray-500 font-medium">
              <img className="mr-3" src="flex-ui-assets/elements/pricing/checkbox-green.svg" />
              <span>E-Mail zum Empfang von EN 16931 kompatiblen Formaten</span>
            </li>
            <li className="flex items-center mb-4 text-coolGray-500 font-medium">
              <img className="mr-3" src="flex-ui-assets/elements/pricing/checkbox-green.svg" />
              <span>Rechnung anzeigen und prüfen</span>
            </li>
            <li className="flex items-center mb-4 text-coolGray-500 font-medium">
              <img className="mr-3" src="flex-ui-assets/elements/pricing/checkbox-green.svg" />
              <span>Rechnungsexport</span>
            </li>
            <li className="flex items-center text-coolGray-500 font-medium">
              <img className="mr-3" src="flex-ui-assets/elements/pricing/checkbox-green.svg" />
              <span>Portalzugang für einen User</span>
            </li>
          </ul>
          <div className="border-b border-coolGray-100" />
          <div className="px-8 pt-8"><a className="inline-block py-4 px-7 w-full text-base md:text-lg leading-6 text-green-50 font-medium text-center bg-green-500 hover:bg-green-600 focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 rounded-md shadow-sm" href="/kontakt">Jetzt starten</a></div>
        </div>
      </div>
      <div className="w-full md:w-1/2 p-4">
        <div className="flex flex-col pt-8 pb-8 bg-coolGray-50 rounded-md shadow-md hover:scale-105 transition duration-500">
          <div className="flex items-center justify-between px-8">
            <div>
              <h3 className="text-2xl md:text-3xl text-coolGray-800 font-semibold tracking-tighter">Fina CRP Enterprise</h3>
              <p className="text-coolGray-400 font-medium">Unlimited possibilities</p>
            </div>
            <div>
              <span className="relative -top-10 right-1 text-3xl text-coolGray-900 font-bold">€</span>
              <span className="text-6xl md:text-7xl text-coolGray-900 font-semibold tracking-tighter">189</span>
              <span className="inline-block ml-1 text-coolGray-500 font-semibold">/mo</span>
            </div>
          </div>
          <div className="border-b border-coolGray-100" />
          <ul className="self-start px-8 pt-8 pb-16">
            <li className="flex items-center mb-4 text-coolGray-500 font-medium">
              <img className="mr-3" src="flex-ui-assets/elements/pricing/checkbox-green.svg" />
              <span>Alle 'Basis'-Funktionen</span>
            </li>
            <li className="flex items-center mb-4 text-coolGray-500 font-medium">
              <img className="mr-3" src="flex-ui-assets/elements/pricing/checkbox-green.svg" />
              <span>Rechnungen kontieren</span>
            </li>
            <li className="flex items-center mb-4 text-coolGray-500 font-medium">
              <img className="mr-3" src="flex-ui-assets/elements/pricing/checkbox-green.svg" />
              <span>Export zum Buchhaltungssystem</span>
            </li>
            <li className="flex items-center text-coolGray-500 font-medium">
              <img className="mr-3" src="flex-ui-assets/elements/pricing/checkbox-green.svg" />
              <span>Program reviews 1x a month</span>
            </li>
          </ul>
          <div className="border-b border-coolGray-100" />
          <div className="px-8 pt-8"><a className="inline-block py-4 px-7 w-full text-base md:text-lg leading-6 text-green-50 font-medium text-center bg-green-500 hover:bg-green-600 focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 rounded-md shadow-sm" href="/kontakt">Jetzt starten</a></div>
        </div>
      </div>
    </div>
  </div>
</section>


            </>
        </React.Fragment>
    );
}

